import { useMemo } from "react";
import { DocOverview } from "../types/docs";
import { MainPath } from "../types/types";
import { UnreachableError } from "./error";

export function guideTitlePerCurrentPath(currentPath: MainPath | null): string {
  if (!currentPath) return "Domino Documentation";
  switch (currentPath) {
    case "admin_guide":
      return "Domino Administrator's Guide";
    case "api_guide":
      return "Domino APIs";
    case "release_notes":
      return "Release Notes";
    case "user_guide":
      return "Domino User's Guide";
    default:
      throw new UnreachableError(currentPath);
  }
}


export function useDocTrace({
  docs,
  id,
}: {
  docs: DocOverview[];
  id: string | undefined;
}) {
  // Only recompute when ID changes
  return useMemo(() => {
    if (!id) return [];
    const result: DocOverview[] = [];

    const found = (function search(nodes: DocOverview[]): boolean {
      for (const doc of nodes) {
        if (doc.id === id || search(doc.children)) {
          result.push(doc);
          return true;
        }
      }
      return false;
    })(docs);

    return found ? result.reverse() : [];
  }, [id]); 
}